import Vue, { markRaw } from 'vue'
// import { DialogProps } from './index.vue'

export const dynamicDialogEventBus = new Vue()

// export interface Instance {
//   key: string
//   visible: boolean
//   options: DialogProps // Dialog props 配置
//   data: any // 组件渲染的数据
//   content: any // 组件
//   close: Function
// }

export const openDialog = (content, data, options = {}) => {
  const instance = {
    key: Math.random().toString(36).substring(2) + '_dynamic_dialog',
    visible: true,
    content: content && markRaw(content),
    options: options || {},
    data,
    close: (params) => {
      dynamicDialogEventBus.$emit('close', { instance, params });
    }
  };

  dynamicDialogEventBus.$emit('open', { instance });

  return instance;
}

export const closeDialog = (key, params) => {
  if (key) {
    dynamicDialogEventBus.$emit('close', { 
      instance: { key },
      params,
    });
  } else {
    dynamicDialogEventBus.$emit('close', { 
      closeprev: true,
      params,
    });
  }
}

export default openDialog